import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { REDIRECT_URI, PKCE_STATE_KEY, PKCE_VERIFIER_KEY, PKCE_PROVIDER_KEY } from "../actions/constants";
import { useAuthStore } from "../store/useAuthStore";

import { Box, Paper, Typography, CircularProgress } from "@mui/material";

const UsersLogin = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const captureOAuthCallback = useAuthStore((s) => s.captureOAuthCallback);
  const finishLogin = useAuthStore((s) => s.finishLogin);

  useEffect(() => {
    (async () => {
      const params = new URLSearchParams(location.search);
      const code = params.get("code");
      const state = params.get("state");

      const storedState = sessionStorage.getItem(PKCE_STATE_KEY);
      const providerFromStorage = sessionStorage.getItem(PKCE_PROVIDER_KEY) || "google";

      const code_verifier = sessionStorage.getItem(PKCE_VERIFIER_KEY) || null;
      const state_valid = !!storedState && !!state && storedState === state;

      if (!code) return navigate("/", { replace: true });
      if (!state_valid) return navigate("/", { replace: true });

      const payload = {
        code,
        redirect_uri: REDIRECT_URI,
        provider: providerFromStorage,
        code_verifier,
        state_valid,
        raw_params: Object.fromEntries(params.entries()),
      };

      captureOAuthCallback({
        code,
        state,
        provider: providerFromStorage,
        redirect_uri: REDIRECT_URI,
        raw_params: payload.raw_params,
        code_verifier,
        state_valid,
      });

      try {
        await finishLogin();
        navigate("/", { replace: true });
      } catch (e) {
        console.error("Error finalizando login:", e);
        navigate("/", { replace: true });
      }
    })();
  }, [location.search, navigate, captureOAuthCallback, finishLogin]);

  return (
    <Box
      sx={{
        minHeight: "60vh",
        display: "grid",
        placeItems: "center",
        px: 2,
      }}
    >
      <Paper
        elevation={0}
        role="status"
        aria-live="polite"
        sx={{
          p: 3,
          borderRadius: 2,
          bgcolor: "background.default",
          border: (theme) => `1px solid ${theme.palette.divider}`,
          maxWidth: 420,
          width: "100%",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          <CircularProgress size={20} thickness={5} color="primary" />
          <Box>
            <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
              Iniciando sesión...
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Estamos finalizando la autenticación. Esto tomará solo un momento…
            </Typography>
          </Box>
        </Box>
      </Paper>
    </Box>
  );
};

export default UsersLogin;
